
/* ====================================================================================================
	Global Variables
	================================================================================================== */

	var timeToWaitForLast = 100;
	var viewport = updateViewportDimensions(); 

/* ==================================================
	Navigation Animation
	=============================================== */

let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("summary").setAttribute("aria-expanded", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      item.querySelector("summary").setAttribute("aria-expanded", false);
    });
  });
  
  });

/* ==================================================
	Open External Links in New Window
	=============================================== */

  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

/* ====================================================================================================
	Functions
	================================================================================================== */

/* ==================================================
	Prevent Multiple Event Triggers on Resize
	=============================================== */

	var waitForFinalEvent = (function () {
		"use strict";
		var timers = {};
		return function (callback, ms, uniqueId) {
			if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }
			if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }
			timers[uniqueId] = setTimeout(callback, ms);
		};
	})();

/* ==================================================
	Update Viewport Dimensions
	=============================================== */

	function updateViewportDimensions() {
		"use strict";
		var w=window,d=document,e=d.documentElement,g=d.getElementsByTagName('body')[0],x=w.innerWidth||e.clientWidth||g.clientWidth,y=w.innerHeight||e.clientHeight||g.clientHeight;
		return { width:x,height:y };
	}

/* ==================================================
	Product Thumbs Height
	=============================================== */

	function productThumbsHeight() {
		"use strict";
    if( viewport.width >= 990 ) {
      let productImageHeight = jQuery('ul.slider').height();
      jQuery('ul.thumbnail-list').height(productImageHeight - 70);
    } else {
      jQuery('ul.thumbnail-list').height('69px');
    }
	}

/* ==================================================
	Product Thumbs Vertical Scroll
	=============================================== */

	function productThumbsVerticalScroll() {
		"use strict";
    if( viewport.width >= 990 ) {
      jQuery('.product__media-gallery .thumbnail-slider').prepend('<button class="scroll up"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>');  
      jQuery('.product__media-gallery .thumbnail-slider').append('<button class="scroll down"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>'); 
  
      jQuery('.product__media-gallery .thumbnail-slider button.scroll.up').on('click', function() {
        let productThumbHeight = jQuery('ul.thumbnail-list li').height();
        $('.product__media-gallery .thumbnail-slider ul').animate({scrollTop: '-=' + productThumbHeight});
      });
      
      jQuery('.product__media-gallery .thumbnail-slider button.scroll.down').on('click', function() {
        console.log('Down Cliked');
        let productThumbHeight = jQuery('ul.thumbnail-list li').height();
        jQuery('.product__media-gallery .thumbnail-slider ul').animate({scrollTop: '+=' + productThumbHeight});
      });   
    } else {
      jQuery('.product__media-gallery .thumbnail-slider button.scroll').hide();
    }
	}

  /* ======================================================================================================
	Document Ready
	================================================================================================== */

$(document).ready(function(){

  "use strict";

  viewport = updateViewportDimensions();

  productThumbsHeight();
  productThumbsVerticalScroll();

/* ==================================================
	Logo Carousel
	=============================================== */

  $('.logo-carousel').slick({
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      infinite: true,
      speed: 300,
      slidesToShow: 8,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
  });

/* ===================================================
		Toggle Filter
		=============================================== */

  $('.toggleFilterContainer button').click(function() {
    if ( $( this ).hasClass( "showing" ) ) {
      $( this ).html('Show Filters').removeClass('showing');
      $( '#main-collection-filters' ).removeClass('showing');
    } else {
      $( this ).html('Hide Filters').addClass('showing');
      $( '#main-collection-filters' ).addClass('showing');
    }
  });

/* ===================================================
		Posts Pagination
		=============================================== */
		    
    $('nav.pagination ul').addClass('pagination');
    $('nav.pagination ul li').addClass('page-item');
    $('nav.pagination ul li a').addClass('page-link');

/* ===================================================
		Read More
		=============================================== */

    $('.read-more-content-excerpt button').click(function() {
      $('.read-more-content-excerpt').stop().animate({
        height: "0px",
      }, 500);
      $('.read-more-content-full').animate({
        height: $('.read-more-content-full').get(0).scrollHeight
      }, 500, function(){
          $(this).height('auto');
      });
    });  

    $('.read-more-content-full button').click(function() {
      $('.read-more-content-full').stop().animate({
        height: "0px",
      }, 500);
      $('.read-more-content-excerpt').animate({
        height: $('.read-more-content-excerpt').get(0).scrollHeight
      }, 500, function(){
          $(this).height('auto');
      });
    });

});



/* ====================================================================================================
	Window Resize
	================================================================================================== */

	window.onresize = function() {
	
		"use strict";
 	
		waitForFinalEvent( function() {
			viewport = updateViewportDimensions();

      productThumbsHeight();

      productThumbsVerticalScroll();

			if( viewport.width >= 768 ) {
				console.log('Window sized to 768 width or more.');
			} else {
				console.log('Window sized to less than 768.');
			}
		}, timeToWaitForLast, "resizeElementsIdentifierString");
		
	}; /* End Window Resize */